import React from 'react';

const RestartIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.71283 5.98484C4.27112 3.3031 7.17499 1.5 10.5 1.5C15.4706 1.5 19.5 5.52944 19.5 10.5C19.5 15.4706 15.4706 19.5 10.5 19.5C5.52944 19.5 1.5 15.4706 1.5 10.5"
        stroke="#424245"
        strokeWidth="1.625"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.12451 6H2.62451V1.5"
        stroke="#424245"
        strokeWidth="1.625"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RestartIcon;
